import { Button, ButtonProps } from "@mui/material";

import { Link, LinkProps } from "react-router-dom";

type ButtonLinkProps = ButtonProps & {
  to: LinkProps["to"];
};

export const ButtonLink = (props: ButtonLinkProps) => {
  return <Button component={Link} {...props} />;
};
